import React from 'react';
import {
    Card, Button, CardImg, CardTitle, CardText, CardGroup,
    CardSubtitle, CardBody, CardFooter, CardHeader, CardColumns, CardDeck
} from 'reactstrap';
import { decompressToBase64, formatter } from '../../utils/common.js'
import "../Items/Item.css";
import Modal from 'react-modal';
import image from "../No_image_available.png";
import ItemModal from '../Items/ItemModal.js'
import { GetCart } from '../ShoppingCart/CartHandler.js';
import parse from 'html-react-parser';
import "react-widgets/styles.css";
import Combobox from "react-widgets/Combobox";
import { Checkbox } from 'pretty-checkbox-react';
import '@djthoms/pretty-checkbox';
import { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import parseWithOptions from 'date-fns/esm/fp/parseWithOptions';

Modal.setAppElement('#root');

const apiUrl = process.env.REACT_APP_BASEURL;

// Please see my two questions: 
// https://stackoverflow.com/questions/68518868/errors-getting-react-modal-in-my-react-component
// https://stackoverflow.com/questions/68512119/how-to-make-multiple-items-fit-on-one-row-in-reactjs

function CategoryProducts ({token, setToken, category, setCategory, page, setPage, isSwiper, setIsSwiper }){
    const [activeItem,setActiveItem] = useState(null);
    const [categoryDescription, setCategoryDescription] = useState(category.description);
    const [encodedValue, setEncodedValue] = useState(category);
    const [filteredItems, setFilteredItems] = useState([]);
    const [items, setItems] = useState([]);
    const [itemList, setItemList] = useState({});
    const[headers, setHeaders] = useState({
        "Accept": "application/json",
        "Content-Type": "application/json",
        'Authorization': 'Bearer ' + token
    })
    const [filters, setFilters] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [metadata1, setMetaData1] = useState("Any");
    const [metadata2, setMetaData2] = useState("Any");
    const [metadata3, setMetaData3] = useState("Any");
    const [metadata4, setMetaData4] = useState("Any");
    const [metadata5, setMetaData5] = useState("Any");
    const [metadata6, setMetaData6] = useState("Any");
    const [metadata7, setMetaData7] = useState("Any");
    const [metadata8, setMetaData8] = useState("Any");
    const [metadata9, setMetaData9] = useState("Any");
    const [metadata10, setMetaData10] = useState("Any");
    const [metadata11, setMetaData11] = useState("Any");
    const [metadata12, setMetaData12] = useState("Any");
    const [metadata13, setMetaData13] = useState("Any");
    const [metadata14, setMetaData14] = useState("Any");
    const [metadata15, setMetaData15] = useState("Any");
    const [metadata16, setMetaData16] = useState("Any");
    const [metadata17, setMetaData17] = useState("Any");
    const [metadata18, setMetaData18] = useState("Any");
    const [metadata19, setMetaData19] = useState("Any");
    const [metadata20, setMetaData20] = useState("Any");
    const [name,setName] = useState('React');
    const [parent, setParent] = useState("");
    const [sort, setSort] = useState("Item A-Z");
    const [subCategories, setSubCategories] = useState([category.children]);
    
    const getCategoryItems = () =>{
        axios.get(apiUrl + `/api/Items/GetSubCategories?category=${category.name}`, {
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                'Authorization': 'Bearer ' + token.token},
            })
        .then((response) => {
        //   console.log("Category Item Response:", response.data);
          if(!Array.isArray(response.data)){
                setItemList([response.data]);
                setFilteredItems([response.data]);
            }else{
                setItemList(response.data);
                setFilteredItems(response.data);
            }
        })
        .catch((error) => {
          console.log(error);
        });
    }

    const getParent = () =>{
        axios.get(apiUrl + `/api/Items/GetCategoryParent?category=${category}`, {
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                'Authorization': 'Bearer ' + token},
            })
        .then((response) => {
        console.log("Category Description Response:", response.data);
        setParent(response.data);})
        .catch((error) => {
          console.log(error);
        });
    }

    const getFilters = () =>{
        axios.get(apiUrl + `/api/Items/GetFilterProperties?category=${category}`, {
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                'Authorization': 'Bearer ' + token},
            })
        .then((response) => {
        // console.log("Category Description Response:", response.data);
        if(!Array.isArray(response.data)){
            setFilters([response.data]);
        }else{
            setFilters(response.data);
        }
        })
        .catch((error) => {
          console.log(error);
        });
    }

    const status = useRef();

    let onRequestClose = () => {
        setIsOpen(false);
        // setCartFunc(GetCart);
    }

    let handleClick = (item) => {
        setActiveItem(item );
        setIsOpen(true);
    }

    let handleSubCategoryClick = (myCategory) => {
        setCategory(myCategory);
    }

    let sortChanged = (e) => {
        setSort(e);
    }

    let filterChanged = (e, name) => {
        // console.log(`Filter ${name} changed to ${e}`);
        if (name === "Metadata1") {setMetaData1(e);}
        if (name === "Metadata2") {setMetaData2(e);}
        if (name === "Metadata3") {setMetaData3(e);}
        if (name === "Metadata4") {setMetaData4(e);}
        if (name === "Metadata5") {setMetaData5(e);}
        if (name === "Metadata6") {setMetaData6(e);}
        if (name === "Metadata7") {setMetaData7(e);}
        if (name === "Metadata8") {setMetaData8(e);}
        if (name === "Metadata9") {setMetaData9(e);}
        if (name === "Metadata10") {setMetaData10(e);}
        if (name === "Metadata11") {setMetaData11(e);}
        if (name === "Metadata12") {setMetaData12(e);}
        if (name === "Metadata13") {setMetaData13(e);}
        if (name === "Metadata14") {setMetaData14(e);}
        if (name === "Metadata15") {setMetaData15(e);}
        if (name === "Metadata16") {setMetaData16(e);}
        if (name === "Metadata17") {setMetaData17(e);}
        if (name === "Metadata18") {setMetaData18(e);}
        if (name === "Metadata19") {setMetaData19(e);}
        if (name === "Metadata20") {setMetaData20(e);}
    }

    useEffect(() => {
        if(!status.current){
            getCategoryItems();
            setSubCategories([category.children]);
            setCategoryDescription(category.description)
            // getParent();
            // getFilters();
            // setEncodedValue(encodeURIComponent(category));
        }
        setItems(filteredItems);
    }, [category]);

    useEffect(() => {
        if(status.current){
            if (metadata1 !== "Any") {
                setFilteredItems(filteredItems.filter(x => x.metadata1 === metadata1));}
            if (metadata2 !== "Any") {
                setFilteredItems(filteredItems.filter(x => x.metadata2 === metadata2));}
            if (metadata3 !== "Any") {
                setFilteredItems(filteredItems.filter(x => x.metadata3 === metadata3));}
            if (metadata4 !== "Any") {
                setFilteredItems(filteredItems.filter(x => x.metadata4 === metadata4));}
            if (metadata5 !== "Any") {
                setFilteredItems(filteredItems.filter(x => x.metadata5 === metadata5));}
            if (metadata6 !== "Any") {
                setFilteredItems(filteredItems.filter(x => x.metadata6 === metadata6));}
            if (metadata7 !== "Any") {
                setFilteredItems(filteredItems.filter(x => x.metadata7 === metadata7));}
            if (metadata8 !== "Any") {
                setFilteredItems(filteredItems.filter(x => x.metadata8 === metadata8));}
            if (metadata3 !== "Any") {
                setFilteredItems(filteredItems.filter(x => x.metadata3 === metadata3));}
            if (metadata9 !== "Any") {
                setFilteredItems(filteredItems.filter(x => x.metadata9 === metadata9));}
            if (metadata10 !== "Any") {
                setFilteredItems(filteredItems.filter(x => x.metadata10 === metadata10));}
            if (metadata11 !== "Any") {
                setFilteredItems(filteredItems.filter(x => x.metadata11 === metadata11));}
            if (metadata12 !== "Any") {
                setFilteredItems(filteredItems.filter(x => x.metadata12 === metadata12));}
            if (metadata13 !== "Any") {
                setFilteredItems(filteredItems.filter(x => x.metadata13 === metadata13));}
            if (metadata14 !== "Any") {
                setFilteredItems(filteredItems.filter(x => x.metadata14 === metadata14));}
            if (metadata15 !== "Any") {
                setFilteredItems(filteredItems.filter(x => x.metadata15 === metadata15));}
            if (metadata16 !== "Any") {
                setFilteredItems(filteredItems.filter(x => x.metadata16 === metadata16));}
            if (metadata17 !== "Any") {
                setFilteredItems(filteredItems.filter(x => x.metadata17 === metadata17));}
            if (metadata18 !== "Any") {
                setFilteredItems(filteredItems.filter(x => x.metadata18 === metadata18));}
            if (metadata19 !== "Any") {
                setFilteredItems(filteredItems.filter(x => x.metadata19 === metadata19));}
            if (metadata20 !== "Any") {
                setFilteredItems(filteredItems.filter(x => x.metadata20 === metadata20));}

            } setItems(filteredItems);
        }, [metadata1,metadata2,metadata3,metadata4,metadata5,metadata6,metadata7,
            metadata8,metadata9,metadata10,metadata11,metadata12,metadata13,metadata14,
            metadata15,metadata16,metadata17,metadata18,metadata19,metadata20] );
            
            useEffect(() => {
                if(status.current){
                    if (sort === "Item A-Z") {
                        setFilteredItems = filteredItems.sort((a, b) => a.itemNumber.localeCompare(b.itemNumber))
                    }
                    if (sort === "Item Z-A") {
                        setFilteredItems = filteredItems.sort((a, b) => b.itemNumber.localeCompare(a.itemNumber))
                    }
                    if (sort === "Price Lo-High") {
                        setFilteredItems = filteredItems.sort((a, b) => a.price - b.price)
                    }
                    if (sort === "Price High-Lo") {
                        setFilteredItems = filteredItems.sort((a, b) => b.price - a.price)
                    }
                }setItems(filteredItems);
                }, [sort] );
    
    
    
                return (
                    <div className="row">
                        <div className="block col-1">
                            <div className="row">
                                <div className="block col-3">                            
                                    {!!parent && <><br /><a className="parent" href="/categoryItems" onClick={() => handleSubCategoryClick(parent)}>{parent}</a><br/></>}
                                    <label className="category">{category}</label>
                                    {!!subCategories && subCategories.map(myCategory =>
                                        <><br/><a className="subcategory" href="/categoryItems" onClick={() => handleSubCategoryClick(myCategory)}>{myCategory}</a></>
                                        )}                           
                                </div>
                                <div className="block col-4">
                                    <p>Sort By:</p>
                                    <Combobox
                                        defaultValue="Item A-Z"
                                        data={["Item A-Z", "Item Z-A", "Price High-Lo", "Price Lo-High"]}
                                        onChange={(event) => sortChanged(event.target.value) }
                                    />
                                    <p style={{ marginBottom: 0 }}>Filters:</p>                   
                                    <button>Reset Filters</button>
                                    <div>
                                        <Checkbox>In Stock Only</Checkbox>
                                    </div>
                                    {filters !== null ? filters.map(filter => 
                                        <div>
                                            <p style={{ marginBottom: 0 }}>{filter.name}</p>
                                            <Combobox defaultValue="Any" data={filter.values} onChange={(e) => filterChanged(e, filter.property)} />
                                            {/*<Combobox value={this.state[filter.property]} defaultValue="Any" data={filter.values} />*/}
                                        </div>) : null}
                                </div>
                            </div>
                        </div>
                        <div className="block col-2">
                            <div>
                                <h3>{!!category ? category : 'All'}</h3>
                                <br />
                            </div>
                            {!!categoryDescription && <p style={{ marginRight: "20px" }}>{parse(categoryDescription)}</p>}
                            {items === null ? <strong style={{ marginLeft: "auto", marginRight: "auto" }}>No items found for this category</strong> : null}
                            <CardColumns className="card-columns-5">                    
                                {!!items && items.map(item =>                        
                                    <Card key={item.itemNumber} onClick={() => handleClick(item)}>
                                        <CardImg top className="card-picture" src={"data:image/png;base64," + decompressToBase64(item.images[0]?.compressedImageData)} id={item.itemNumber + "Img"} alt={item.itemNumber} />
                                        <CardBody className="card-body">
                                            <CardTitle >{item.itemNumber}</CardTitle><br />                                    
                                            {item.available !== null ? <><CardText className="card-description-short w-[14rem]">{item.itemDescription}</CardText><CardText>{item.available}</CardText></> : <CardText className="card-description">{item.itemDescription}</CardText>}
                                        </CardBody>
                                        <CardFooter className="text-muted">{formatter.format(item.price)}</CardFooter>
                                    </Card>                  
                                )}
                            </CardColumns>
                            {isOpen ? <ItemModal isSwiper={isSwiper} setIsSwiper={setIsSwiper}  item={activeItem} onRequestClose={onRequestClose} /> : null}
                        </div>
                    </div>
                );
            }

// class CategoryProducts extends React.Component {
    // constructor() {
    //     super();
    //     this.state = {
    //         name: 'React',
    //         apiData: [],
    //         subCategories: [],
    //         activeItem: null,
    //         isOpen: false,
    //         categoryDescription: "",
    //         parent: "",
    //         filters: [],
    //         sort: "Item A-Z",
    //         metadata1: "Any",
    //         metadata2: "Any",
    //         metadata3: "Any",
    //         metadata4: "Any",
    //         metadata5: "Any",
    //         metadata6: "Any",
    //         metadata7: "Any",
    //         metadata8: "Any",
    //         metadata9: "Any",
    //         metadata10: "Any",
    //         metadata11: "Any",
    //         metadata12: "Any",
    //         metadata13: "Any",
    //         metadata14: "Any",
    //         metadata15: "Any",
    //         metadata16: "Any",
    //         metadata17: "Any",
    //         metadata18: "Any",
    //         metadata19: "Any",
    //         metadata20: "Any"
    //     };
    // }

    // async componentDidMount() {
        // const tokenString = sessionStorage.getItem("token");
        // const token = JSON.parse(tokenString);

        // let headers = new Headers({
        //     "Accept": "application/json",
        //     "Content-Type": "application/json",
        //     'Authorization': 'Bearer ' + token.token
        // });

        // let category = 'All'

        // if (!!sessionStorage.getItem("category")) {
        //     category = sessionStorage.getItem("category")
        // }        

        // const encodedValue = encodeURIComponent(category);

        // const response = await fetch(apiUrl + `/api/Items/GetAll?category=${encodedValue}`, {
        //     method: "GET",
        //     headers: headers
        // });

        // const json = await response.json();
        // console.log(json);

        // if (Array.isArray(json)) {
        //     this.setState({ itemList: json });
        //     this.setState({ filteredItems: json });
        // }
        // else {
        //     this.setState({ itemList: null });
        //     this.setState({ filteredItems: null });
        // }

        // const response2 = await fetch(apiUrl + `/api/Items/GetSubCategories?category=${encodedValue}`, {
        //     method: "GET",
        //     headers: headers
        // });
        // const json2 = await response2.json();

        // this.setState({ subCategories: json2 });     

        // const response3 = await fetch(apiUrl + `/api/Items/GetCategoryDescription?category=${encodedValue}`, {
        //     method: "GET",
        //     headers: headers
        // });
        // const json3 = await response3.json();

        // this.setState({ categoryDescription: json3 });   

        // const response4 = await fetch(apiUrl + `/api/Items/GetCategoryParent?category=${encodedValue}`, {
        //     method: "GET",
        //     headers: headers
        // });
        // const json4 = await response4.json();

        // this.setState({ parent: json4 });  

    //     const response5 = await fetch(apiUrl + `/api/Items/GetFilterProperties?category=${encodedValue}`, {
    //         method: "GET",
    //         headers: headers
    //     });
    //     const json5 = await response5.json();

    //     this.setState({ filters: json5 });  
    // }

    // async componentDidUpdate(_, prevState) {
    //     if (prevState.metadata1 !== this.state.metadata1
    //         || prevState.metadata2 !== this.state.metadata2
    //         || prevState.metadata3 !== this.state.metadata3
    //         || prevState.metadata4 !== this.state.metadata4
    //         || prevState.metadata5 !== this.state.metadata5
    //         || prevState.metadata6 !== this.state.metadata6
    //         || prevState.metadata7 !== this.state.metadata7
    //         || prevState.metadata8 !== this.state.metadata8
    //         || prevState.metadata9 !== this.state.metadata9
    //         || prevState.metadata10 !== this.state.metadata10
    //         || prevState.metadata11 !== this.state.metadata11
    //         || prevState.metadata12 !== this.state.metadata12
    //         || prevState.metadata13 !== this.state.metadata13
    //         || prevState.metadata14 !== this.state.metadata14
    //         || prevState.metadata15 !== this.state.metadata15
    //         || prevState.metadata16 !== this.state.metadata16
    //         || prevState.metadata17 !== this.state.metadata17
    //         || prevState.metadata18 !== this.state.metadata18
    //         || prevState.metadata19 !== this.state.metadata19
    //         || prevState.metadata20 !== this.state.metadata20) {
    //         console.log("componentDidUpdate is running")
    //         var filteredItems = this.state.itemList;

    //         if (this.state.metadata1 !== "Any") {
    //             filteredItems = filteredItems.filter(x => x.metadata1 === this.state.metadata1);
    //         }

    //         if (this.state.metadata2 !== "Any") {
    //             filteredItems = filteredItems.filter(x => x.metadata2 === this.state.metadata2);
    //         }

    //         if (this.state.metadata3 !== "Any") {
    //             filteredItems = filteredItems.filter(x => x.metadata3 === this.state.metadata3);
    //         }

    //         if (this.state.metadata4 !== "Any") {
    //             filteredItems = filteredItems.filter(x => x.metadata4 === this.state.metadata4);
    //         }

    //         if (this.state.metadata5 !== "Any") {
    //             filteredItems = filteredItems.filter(x => x.metadata5 === this.state.metadata5);
    //         }

    //         if (this.state.metadata6 !== "Any") {
    //             filteredItems = filteredItems.filter(x => x.metadata6 === this.state.metadata6);
    //         }

    //         if (this.state.metadata7 !== "Any") {
    //             filteredItems = filteredItems.filter(x => x.metadata7 === this.state.metadata7);
    //         }

    //         if (this.state.metadata8 !== "Any") {
    //             filteredItems = filteredItems.filter(x => x.metadata8 === this.state.metadata8);
    //         }

    //         if (this.state.metadata3 !== "Any") {
    //             filteredItems = filteredItems.filter(x => x.metadata3 === this.state.metadata3);
    //         }

    //         if (this.state.metadata9 !== "Any") {
    //             filteredItems = filteredItems.filter(x => x.metadata9 === this.state.metadata9);
    //         }

    //         if (this.state.metadata10 !== "Any") {
    //             filteredItems = filteredItems.filter(x => x.metadata10 === this.state.metadata10);
    //         }

    //         if (this.state.metadata11 !== "Any") {
    //             filteredItems = filteredItems.filter(x => x.metadata11 === this.state.metadata11);
    //         }

    //         if (this.state.metadata12 !== "Any") {
    //             filteredItems = filteredItems.filter(x => x.metadata12 === this.state.metadata12);
    //         }

    //         if (this.state.metadata13 !== "Any") {
    //             filteredItems = filteredItems.filter(x => x.metadata13 === this.state.metadata13);
    //         }

    //         if (this.state.metadata14 !== "Any") {
    //             filteredItems = filteredItems.filter(x => x.metadata14 === this.state.metadata14);
    //         }

    //         if (this.state.metadata15 !== "Any") {
    //             filteredItems = filteredItems.filter(x => x.metadata15 === this.state.metadata15);
    //         }

    //         if (this.state.metadata16 !== "Any") {
    //             filteredItems = filteredItems.filter(x => x.metadata16 === this.state.metadata16);
    //         }

    //         if (this.state.metadata17 !== "Any") {
    //             filteredItems = filteredItems.filter(x => x.metadata17 === this.state.metadata17);
    //         }

    //         if (this.state.metadata18 !== "Any") {
    //             filteredItems = filteredItems.filter(x => x.metadata18 === this.state.metadata18);
    //         }

    //         if (this.state.metadata19 !== "Any") {
    //             filteredItems = filteredItems.filter(x => x.metadata19 === this.state.metadata19);
    //         }

    //         if (this.state.metadata20 !== "Any") {
    //             filteredItems = filteredItems.filter(x => x.metadata20 === this.state.metadata20);
    //         }

    //         console.log(`Filtered Items: ${filteredItems}`)
    //         this.setState({ filteredItems: filteredItems });
    //     }

    //     if (prevState.sort !== this.state.sort) {
    //         var filteredItems = this.state.filteredItems;

    //         if (this.state.sort === "Item A-Z") {
    //             filteredItems = filteredItems.sort((a, b) => a.itemNumber.localeCompare(b.itemNumber))
    //         }

    //         if (this.state.sort === "Item Z-A") {
    //             filteredItems = filteredItems.sort((a, b) => b.itemNumber.localeCompare(a.itemNumber))
    //         }

    //         if (this.state.sort === "Price Lo-High") {
    //             filteredItems = filteredItems.sort((a, b) => a.price - b.price)
    //         }

    //         if (this.state.sort === "Price High-Lo") {
    //             filteredItems = filteredItems.sort((a, b) => b.price - a.price)
    //         }

    //         this.setState({ filteredItems: filteredItems });
    //     }
    // }

    // render() {
        // const items = this.state.filteredItems;
        // const { isOpen } = this.state;
        // const { activeItem } = this.state;              

        // let onRequestClose = () => {
        //     this.setState({ isOpen: false });
        //     this.props.setCartFunc(GetCart);
           
        // }

        // let handleClick = (item) => {
        //     this.setState({ activeItem: item });
        //     this.setState({ isOpen: true });
        // }

        // let handleSubCategoryClick = (category) => {
        //     console.log(`you clicked ${category}`)
        //     sessionStorage.removeItem("category");
        //     sessionStorage.setItem("category", category);
        // }

        // let sortChanged = (e) => {
        //     this.setState({ sort: e })
        // }

        // let filterChanged = (e, name) => {
        //     console.log(`Filter ${name} changed to ${e}`);
        //     if (name === "Metadata1") {
        //         setMetadata1: e})
        //     }

        //     if (name === "Metadata2") {
        //         this.setState({ metadata2: e })
        //     }

        //     if (name === "Metadata3") {
        //         this.setState({ metadata3: e })
        //     }

        //     if (name === "Metadata4") {
        //         this.setState({ metadata4: e })
        //     }

        //     if (name === "Metadata5") {
        //         this.setState({ metadata5: e })
        //     }

        //     if (name === "Metadata6") {
        //         this.setState({ metadata6: e })
        //     }

        //     if (name === "Metadata7") {
        //         this.setState({ metadata7: e })
        //     }

        //     if (name === "Metadata8") {
        //         this.setState({ metadata8: e })
        //     }

        //     if (name === "Metadata9") {
        //         this.setState({ metadata9: e })
        //     }

        //     if (name === "Metadata10") {
        //         this.setState({ metadata10: e })
        //     }

        //     if (name === "Metadata11") {
        //         this.setState({ metadata11: e })
        //     }

        //     if (name === "Metadata12") {
        //         this.setState({ metadata12: e })
        //     }

        //     if (name === "Metadata13") {
        //         this.setState({ metadata13: e })
        //     }

        //     if (name === "Metadata14") {
        //         this.setState({ metadata14: e })
        //     }

        //     if (name === "Metadata15") {
        //         this.setState({ metadata15: e })
        //     }

        //     if (name === "Metadata16") {
        //         this.setState({ metadata16: e })
        //     }

        //     if (name === "Metadata17") {
        //         this.setState({ metadata17: e })
        //     }

        //     if (name === "Metadata18") {
        //         this.setState({ metadata18: e })
        //     }

        //     if (name === "Metadata19") {
        //         this.setState({ metadata19: e })
        //     }

        //     if (name === "Metadata20") {
        //         this.setState({ metadata20: e })
        //     }
        // }

//         return (
//             <div className="row">
//                 <div className="block col-1">
//                     <div className="row">
//                         <div className="block col-3">                            
//                             {!!this.state.parent && <><br /><a className="parent" href="/categoryItems" onClick={() => handleSubCategoryClick(this.state.parent)}>{this.state.parent}</a><br/></>}
//                             <label className="category">{sessionStorage.getItem("category")}</label>
//                             {!!this.state.subCategories && this.state.subCategories.map(category =>
//                                 <><br/><a className="subcategory" href="/categoryItems" onClick={() => handleSubCategoryClick(category)}>{category}</a></>
//                                 )}                           
//                         </div>
//                         <div className="block col-4">
//                             <p>Sort By:</p>
//                             <Combobox
//                                 defaultValue="Item A-Z"
//                                 data={["Item A-Z", "Item Z-A", "Price High-Lo", "Price Lo-High"]}
//                                 onChange={(e) => sortChanged(e) }
//                             />
//                             <p style={{ marginBottom: 0 }}>Filters:</p>                   
//                             <button>Reset Filters</button>
//                             <div>
//                                 <Checkbox>In Stock Only</Checkbox>
//                             </div>
//                             {this.state.filters !== null ? this.state.filters.map(filter => 
//                                 <div>
//                                     <p style={{ marginBottom: 0 }}>{filter.name}</p>
//                                     <Combobox defaultValue="Any" data={filter.values} onChange={(e) => filterChanged(e, filter.property)} />
//                                     {/*<Combobox value={this.state[filter.property]} defaultValue="Any" data={filter.values} />*/}
//                                 </div>) : null}
//                         </div>
//                     </div>
//                 </div>
//                 <div className="block col-2">
//                     <div>
//                         <h3>{!!sessionStorage.getItem("category") ? sessionStorage.getItem("category") : 'All'}</h3>
//                         <br />
//                     </div>
//                     {!!this.state.categoryDescription && <p style={{ marginRight: "20px" }}>{parse(this.state.categoryDescription)}</p>}
//                     {items === null ? <strong style={{ marginLeft: "auto", marginRight: "auto" }}>No items found for this category</strong> : null}
//                     <CardColumns className="card-columns-5">                    
//                         {!!items && items.map(item =>                        
//                             <Card key={item.itemNumber}>
//                                 <CardImg top className="card-picture" src={"data:image/png;base64," + decompressToBase64(item.images[0]?.compressedImageData)} id={item.itemNumber + "Img"} alt={item.itemNumber} />
//                                 <CardBody className="card-body">
//                                     <CardTitle tag="a" onClick={() => handleClick(item)} style={{ cursor: "pointer" }}>{item.itemNumber}</CardTitle><br />                                    
//                                     {item.available !== null ? <><CardText className="card-description-short">{item.itemDescription}</CardText><CardText>{item.available}</CardText></> : <CardText className="card-description">{item.itemDescription}</CardText>}
//                                 </CardBody>
//                                 <CardFooter className="text-muted">{formatter.format(item.price)}</CardFooter>
//                             </Card>                  
//                         )}
//                     </CardColumns>
//                     {isOpen ? <ItemModal item={activeItem} onRequestClose={onRequestClose} /> : null}
//                 </div>
//             </div>
//         );
//     }
// }
export default CategoryProducts;